import type { ApiErrorResponse } from '@/shared/api/types';
import { isAxiosError } from 'axios';

/** 파트너 API ErrorCode 중 화면 분기에 쓰는 것 */
export const PARTNER_ERROR_CODES = {
  /** 401 이메일·비밀번호 불일치 */
  LOGIN_FAILED: 'PARTNER_LOGIN_FAILED',
  /** 429 5회 연속 실패 → 15분 차단 */
  LOGIN_ATTEMPTS_EXCEEDED: 'PARTNER_LOGIN_ATTEMPTS_EXCEEDED',
  /** 403 이용 중지 계정·업체 (비밀번호가 맞을 때만) */
  ACCOUNT_SUSPENDED: 'PARTNER_ACCOUNT_SUSPENDED',
  /** 401 세션 폐기·만료·계정 변경 */
  INVALID_TOKEN: 'INVALID_PARTNER_TOKEN',
  /** 404 상세 패널 — 업체 범위 밖 담당자·병의원 */
  TRADE_NOT_FOUND: 'PARTNER_TRADE_NOT_FOUND',
  /** 400 처방 등록 이미지 2,000장 초과 */
  IMAGE_ARCHIVE_TOO_MANY: 'PARTNER_PRESCRIPTION_IMAGE_ARCHIVE_TOO_MANY',
  /** 404 조건에 맞는 처방 등록 이미지 없음 */
  IMAGE_ARCHIVE_EMPTY: 'PARTNER_PRESCRIPTION_IMAGE_ARCHIVE_EMPTY',
  /** 503 압축 대기열이 가득 참 */
  IMAGE_ARCHIVE_BUSY: 'PARTNER_PRESCRIPTION_IMAGE_ARCHIVE_BUSY',
  /** 404 없는·다른 업체의 압축 작업 */
  IMAGE_ARCHIVE_JOB_NOT_FOUND:
    'PARTNER_PRESCRIPTION_IMAGE_ARCHIVE_JOB_NOT_FOUND',
  /** 400 확정 처방 50,000행 초과 */
  FINALIZED_EXPORT_TOO_MANY: 'PARTNER_FINALIZED_PRESCRIPTION_EXPORT_TOO_MANY',
  /** 404 조건에 맞는 확정 처방 없음 */
  FINALIZED_EXPORT_EMPTY: 'PARTNER_FINALIZED_PRESCRIPTION_EXPORT_EMPTY',
} as const;

/** 에러 본문을 꺼낸다. 본문이 없거나 형식이 다르면 null. */
export const getApiError = (error: unknown): ApiErrorResponse | null => {
  if (!isAxiosError(error)) return null;
  const data: unknown = error.response?.data;
  if (data == null || typeof data !== 'object') return null;
  const { code, message, errors } = data as Partial<ApiErrorResponse>;
  if (typeof code !== 'string' || typeof message !== 'string') return null;
  return { code, message, errors: Array.isArray(errors) ? errors : undefined };
};

/** 서버 문구를 우선하고, 없으면(네트워크 오류·본문 없는 401 등) fallback */
export const getApiErrorMessage = (error: unknown, fallback: string) =>
  getApiError(error)?.message?.trim() || fallback;
